import type {IncubatorInitialPresetsShape} from 'app/utils/incubatorInitialPresetsFields';

export type IncubatorCreateFormPresets = IncubatorInitialPresetsShape;

interface Params {
    isEditable: boolean
    isOpenModal: boolean
    previousPresets?: IncubatorCreateFormPresets | null
    nextPresets?: IncubatorCreateFormPresets | null
}

export const incubatorCreateFormPresetsEqual = (
    previous?: IncubatorCreateFormPresets | null,
    next?: IncubatorCreateFormPresets | null
): boolean => {
    if (previous === next) {
        return true;
    }

    if (!previous || !next) {
        return !previous && !next;
    }

    return Number(previous.delay_for_bets_time) === Number(next.delay_for_bets_time) &&
        Number(previous.coef_changing) === Number(next.coef_changing) &&
        Boolean(previous.consider_personal_limits) === Boolean(next.consider_personal_limits) &&
        Boolean(previous.hide_creator) === Boolean(next.hide_creator);
};

export const shouldSyncIncubatorCreateFormFromPresets = ({
    isEditable,
    isOpenModal,
    previousPresets,
    nextPresets
}: Params): boolean => {
    if (isEditable || isOpenModal) {
        return false;
    }

    return !incubatorCreateFormPresetsEqual(previousPresets, nextPresets);
};
